import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  PageListBean,
  PurchaseOrderUnApprovedCriteriaBean,
  RestPageListBean,
  RestReadRequest,
  RestVendorListRequest,
  unApprovedPurchaseOrderPrintRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupPurchaseOrderModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import CustomTable from "../gui_components/CustomTable.js";
class POUnApprovedInfo extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "PO UnApproved Infos Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new PurchaseOrderUnApprovedCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      moduleForPopup: [],
      inquiryData: null,
      showAutoCompleteList: true,
      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: true,
      isDisableFields: false,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
    };
    this.vendorCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };

  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.loadPOUnApprovedInfoList(criteria);
  };
  loadPOUnApprovedInfoList = (criteria) => {
    if (SecurityAccessManager.PurchaseOrderUnApprovedDetails_IsAccessible()) {
      ReportService.getUnApprovedPurchaseOrders(
        criteria,
        this.loadPOUnApprovedInfoPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPOUnApprovedInfoPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let poList = [];
      if (!isEmptyArray(response.data.unApprovedPurchaseOrders)) {
        poList = response.data.unApprovedPurchaseOrders;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: poList,
        isLoading: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new PurchaseOrderUnApprovedCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.vendorName = "";
    this.setState({
      criteria: criteria,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let criteria = new PurchaseOrderUnApprovedCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.vendorName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new unApprovedPurchaseOrderPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.PurchaseOrderUnApprovedDetailsPDFReport_IsAccessible()
      ) {
        ReportService.generateunApprovedPurchaseOrderPrintReport(
          listRequest,
          this.generatePOUnApprovedPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.PurchaseOrderUnApprovedDetailsExcelReport_IsAccessible()
      ) {
        ReportService.generateunApprovedPurchaseOrderPrintReport(
          listRequest,
          this.generatePOUnApprovedPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generatePOUnApprovedPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generatePOUnApprovedPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
               window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewPOModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseOrderModule: isOpen,
      isShowVendorModule: isOpen,
      moduleForPopup: [],
    });
  };
  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let criteria = this.state.criteria;
      criteria.vendorCode = "";
      criteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        criteria.vendorName = vendorData.description;
        criteria.vendorCode = vendorData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack
    );
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack
    );
  }
  readByVendorCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.vendorPageList != null &&
      response.data.vendorPageList.vendors != null
    ) {
      let vendorCodeData = response.data.vendorPageList.vendors;
      let simpleAutoCompleteList = new Array();
      if (vendorCodeData.length > 0 && vendorCodeData != null) {
        vendorCodeData.map((vendorCode) => {
          let simpleItemBean = {
            code: vendorCode.code,
            description: vendorCode.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        vendorPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "code", true)
        .setStyleDetails("left", "2", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewPOModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor#", "vendorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "orderDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StartDate", "orderStartDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "orderStopDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("GrandTotAmt", "grandTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderedQty", "purchaseOrderTotalQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          vendorCodeRef={this.vendorCodeRef}
          vendorCodeOnChange={this.vendorCodeOnChange}
          vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
          displayAutoCompleteVendorList={this.displayAutoCompleteVendorList}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const vendorCodeOnChange = (e) => props.vendorCodeOnChange(e);
  let criteria = props.criteria;
  let vendorLookupHandler = props.vendorLookupHandler;
  const vendorCodeRef = props.vendorCodeRef;
  const vendorCodeEnterKeyEventHandler = (e) => {
    props.vendorCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteVendorList = () => {
    props.displayAutoCompleteVendorList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Vendor</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={vendorCodeRef}
            name="vendorCode"
            onChange={vendorCodeOnChange}
            value={criteria.vendorCode}
            lookupRequired={true}
            lookupHandler={vendorLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={vendorCodeEnterKeyEventHandler}
            autoCompleteListData={props.vendorPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteVendorList}
            showAutoCompleteList={props.showAutoCompleteVendorList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="vendorName"
            onChange={onChange}
            value={criteria.vendorName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>StartDate#</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="startDate"
            value={criteria.startDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>StopDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="stopDate"
            onChange={onChange}
            value={criteria.stopDate}
            disabled={props.isDisableFields}
          />
        </Col>
      </Row>
    </div>
  );
}
function POUnApprovedInfoInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <POUnApprovedInfo {...props} name="" /> <br />
    </div>
  );
}

export default POUnApprovedInfoInquiry;
